module.exports = __webpack_public_path__ + "img/frame (116).f93af2bf.jpg";